/** Get enough basic information about one feed to start loading sprite sheets */
export const feedGetSpec = {
    uri: '/t/[tenant]/feed/[feed]',
    method: 'GET',
};
